import { AxiosError } from 'axios';
import { ApiError } from 'types/api';

export const getErrorMessage = (
  error: AxiosError<ApiError>,
  defaultMessage: string = ''
): string => {
  const apiError = error.response?.data;
  if (apiError?.error?.length) {
    return apiError.error[0].msg || defaultMessage;
  } else {
    return error.message || defaultMessage;
  }
};

export const encodeBase64 = (file: File): Promise<string> => {
  return new Promise((resolve) => {
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const { result } = fileReader;
      const prefixRegex = /data:(.*);base64,/;
      const trimmed = (result as string)?.replace(prefixRegex, '');
      resolve(trimmed);
    };
    fileReader.readAsDataURL(file);
  });
};

export const formatMoneyToCents = (money: number) => Math.floor(money * 100);

export const getGoogleRecaptchaToken = async (action: string = 'SUBMIT') => {
  await new Promise((resolve) => window.grecaptcha.enterprise.ready(resolve));
  const token = await window.grecaptcha.enterprise.execute(
    process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY,
    { action }
  );
  return token;
};

export const normalizePhoneNumber = (phoneNumber: string) =>
  phoneNumber?.replace(/[^\d]/g, '');

export const normalizePostalCode = (postalCode: string) => {
  return postalCode.toUpperCase().replace(/\s/g, '');
};

export const removeEmpty = (data: Record<string, any>): Record<string, any> => {
  const result: Record<string, any> = {};
  Object.keys(data).forEach((key) => {
    if (!!data[key]) {
      result[key] = data[key];
    }
  });
  return result;
};

export const getLocaleCode = (locale: string = 'en') => {
  const languageCode = locale.slice(0, 2);
  switch (languageCode) {
    case 'fr':
      return 'fr-CA';
    case 'es':
      return 'es-US';
    default:
      return 'en-US';
  }
};
